<template>
  <div>
    <h3>Hasil Testing</h3>
    <McAvatar
      :text="text"
      :image="image"
      :variant="variant"
      :size="size"
      :badgeText="badgeText"
      :badgeType="badgeType"
      :badgeVariant="badgeVariant"
      :badgePosition="badgePosition"
    ></McAvatar>
    <h3 class="mt-4">Avatar Small</h3>
    <McAvatar class="me-2" text="ME" size="small"></McAvatar>
    <McAvatar class="me-2" text="ME" size="small" badgeText="99"></McAvatar>
    <McAvatar class="me-2" text="ME" size="small" badgeText="99" badgeType="notif"></McAvatar>
    <McAvatar
      class="me-2"
      text="ME"
      size="small"
      badgeText="99"
      badgeType="notif"
      badgePosition="bottom"
    ></McAvatar>
    <McAvatar
      class="me-2"
      text="ME"
      image="https://us.123rf.com/450wm/rawpixel/rawpixel1711/rawpixel171107564/90814914-woman-journalist-shoot.jpg"
      size="small"
    ></McAvatar>
    <h3 class="mt-4">Avatar Medium</h3>
    <McAvatar class="me-2" text="ME" size="medium"></McAvatar>
    <McAvatar class="me-2" text="ME" size="medium" badgeText="99"></McAvatar>
    <McAvatar class="me-2" text="ME" size="medium" badgeText="99" badgeType="notif"></McAvatar>
    <McAvatar
      class="me-2"
      text="ME"
      size="medium"
      badgeText="99"
      badgeType="notif"
      badgePosition="bottom"
    ></McAvatar>
    <McAvatar
      class="me-2"
      text="ME"
      image="https://us.123rf.com/450wm/rawpixel/rawpixel1711/rawpixel171107564/90814914-woman-journalist-shoot.jpg"
      size="medium"
    ></McAvatar>
    <h3 class="mt-4">Avatar Large</h3>
    <McAvatar class="me-2" text="ME" size="large"></McAvatar>
    <McAvatar class="me-2" text="ME" size="large" badgeText="99"></McAvatar>
    <McAvatar class="me-2" text="ME" size="large" badgeText="99" badgeType="notif"></McAvatar>
    <McAvatar
      class="me-2"
      text="ME"
      size="large"
      badgeText="99"
      badgeType="notif"
      badgePosition="bottom"
    ></McAvatar>
    <McAvatar
      class="me-2"
      text="ME"
      image="https://us.123rf.com/450wm/rawpixel/rawpixel1711/rawpixel171107564/90814914-woman-journalist-shoot.jpg"
      size="large"
    ></McAvatar>
    <h3 class="mt-4">Avatar Variant</h3>
    <McAvatar class="me-2" text="ME" variant="outlinePrimary"></McAvatar>
    <McAvatar class="me-2" text="ME" variant="outlineSecondary"></McAvatar>
    <McAvatar class="me-2" text="ME" variant="outlineSuccess"></McAvatar>
    <McAvatar class="me-2" text="ME" variant="outlineDanger"></McAvatar>
    <McAvatar class="me-2" text="ME" variant="outlineWarning"></McAvatar>
    <McAvatar class="me-2" text="ME" variant="outlineInfo"></McAvatar>
    <McAvatar class="me-2" text="ME" variant="outlinePink"></McAvatar>
    <McAvatar class="me-2" text="ME" variant="outlinePurple"></McAvatar>
  </div>
</template>
    <script>
import McAvatar from './index'

export default {
  components: {
    McAvatar,
  },

  props: {
    text: {
      type: String,
      required: true,
    },
    image: {
      type: String,
    },
    variant: {
      type: String,
      default: 'outlinePrimary',
    },
    size: {
      type: String,
      default: 'medium',
    },

    badgeText: {
      type: String,
    },

    badgeType: {
      type: String,
      default: 'pill',
    },

    badgeVariant: {
      type: String,
      default: 'canceled',
    },

    badgePosition: {
      type: String,
      default: 'top',
    },
  },
}
</script>
    